<template>
  <main class="page">
    <AppBack/>

    <AppPageHeader
      :title="isCreate ? 'Создать технику' : 'Редактировать технику'"
    />

    <section class="section">
      <div class="form__bg">
        <div class="form__inputs">
          <AppInput title="Наименование"
                    required
                    :value="transport.name"
                    :valid="validation.name"
                    @value-changed="setName"
                    @got-focus="clearValidation('name')"
          />
          <AppInput title="Гос. Номер"
                    required
                    :value="transport.number"
                    :valid="validation.number"
                    @value-changed="setNumber"
                    @got-focus="clearValidation('number')"
          />
        </div>

        <div class="form__inputs form__inputs_col-1">
          <AppTextarea title="Комментарий"
                       :value="transport.comment"
                       @value-changed="setComment"
          />

          <AppInputFile
            :value="transport.scans"
            title="Сканы ПТС"
            name="scans"
            @value-changed="setScans"
            @delete-file="addScanFileToDelete"
          />
        </div>

        <div class="form__inputs">
          <VSelect
            label="Водители"
            v-model="transport.drivers"
            name="drivers"
            item-text="full_name"
            :items="driverList"
            :handler-search="GETLogisticDriverList"
            search
            multiple
          />

          <AppInput title="Сортировка (цифра)"
                    :value="transport.sort_order"
                    :valid="validation.sort_order"
                    required
                    @value-changed="setSort"
                    @got-focus="clearValidation('sort_order')"
          />

          <AppCheckbox title="Не рабочий одометр"
                       :checked="transport.is_not_odometer"
                       :value="transport.is_not_odometer"
                       @toggle-check="toggleOdometer"
          />
        </div>
      </div>

      <section class="section page__content">
        <AppTabsSlider
          class="mb-40"
          :tabs="tabs"
        />

        <transition name="fade" mode="out-in">
          <router-view/>
        </transition>
      </section>

    </section>

    <section class="section page__footer d-flex gap-16">
      <AppButton
        :title="isCreate ? 'Создать' : 'Сохранить'"
        type="main"
        @click.native="saveTransportInfo"
      />

      <AppButton
        title="Отмена"
        type="alt"
        @click.prevent.native="leavePage"
      />
    </section>

    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import AppButton from '@/components/page/button/AppButton'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import AppInput from '@/components/page/input/AppInput'
import AppTextarea from '@/components/page/input/AppTextarea'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import AppTabsSlider from '@/components/page/tabs/AppTabsSlider'
import AppInputFile from '@/components/page/input/AppInputFile'
import AppBack from '@/components/page/AppBack'
import AppPageHeader from '@/components/page/AppPageHeader'
import VSelect from '@/components/page/Form/VSelect'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'LogisticTransportUpdate',
  components: {
    VSelect,
    AppPageHeader,
    AppInputFile,
    AppTabsSlider,
    AppCheckbox,
    AppTextarea,
    AppInput,
    AppButton,
    ThePagePreloader,
    AppBack
  },
  data: () => ({
    isCreate: false,
    tabs: [
      { name: 'Топливо', routeName: 'LogisticTransportUpdate_fuel' },
      { name: 'Арендная ставка', routeName: 'LogisticTransportUpdate_rent' },
      { name: 'Водитель', routeName: 'LogisticTransportUpdate_driver' }
    ]
  }),
  computed: {
    ...mapState('handbook/logistic', {
      driverList: 'driverList',
      fuelList: 'fuelList'
    }),
    ...mapState('logistic/transportUpdate', {
      transport: 'transport',
      validation: 'validation',
      isLoading: 'isLoading'
    })
  },

  async mounted () {
    const id = this.$router.history.current.params.id

    this.setInitialState()

    if (id === 'create') {
      this.isCreate = true
    } else {
      await this.getTransportItem(id)
      this.isCreate = false
    }

    await Promise.all([
      this.GETLogisticDriverList(),
      this.GETLogisticFuelList()
    ])

    this.SET_TRANSPORT_ITEM_FUELS(this.fuelList)
  },

  destroyed () {
    this.RESET_FILES_TO_DELETE()
  },

  methods: {
    ...mapActions('handbook/logistic', {
      GETLogisticDriverList: 'GETLogisticDriverList',
      GETLogisticFuelList: 'GETLogisticFuelList'
    }),

    ...mapMutations('logistic/transportUpdate', {
      RESET_FILES_TO_DELETE: 'RESET_FILES_TO_DELETE',
      SET_TRANSPORT_ITEM_FUELS: 'SET_TRANSPORT_ITEM_FUELS',
      setName: 'SET_TRANSPORT_ITEM_NAME',
      setNumber: 'SET_TRANSPORT_ITEM_NUMBER',
      setComment: 'SET_TRANSPORT_ITEM_COMMENT',
      setSort: 'SET_TRANSPORT_ITEM_SORT_ORDER',
      toggleOdometer: 'SET_TRANSPORT_ITEM_ODOMETER',
      clearValidation: 'CLEAR_TRANSPORT_ITEM_VALIDATION',
      setScans: 'SET_TRANSPORT_ITEM_SCANS',
      setInitialState: 'SET_TRANSPORT_ITEM_INITIAL_STATE'
    }),

    ...mapActions('logistic/transportUpdate', {
      getTransportItem: 'getTransportItem',
      saveTransportInfo: 'saveTransportItem',
      addScanFileToDelete: 'addScanFileToDelete'
    }),

    leavePage () {
      this.$router.push({ name: 'LogisticTransportList' })
    }
  }
}
</script>
